//@ts-nocheck
import React, {useState, useEffect} from "react";
import TaskActionButtons from "./TaskActionButtons.component";
import translate from "components/translations/translations.wrapper.jsx";
import * as reduxSelectors from "components/store/application.reducers";
import {connect} from "react-redux";
import {DOCUMENT_TYPE, LOADING_STATUS} from "utils/constants";
import _ from "lodash";
import {useNavigate} from "react-router-dom";
import { Button, ButtonType } from "components/common/Button.component";
import { ArrowLeftIcon, ChevronLeftIcon, ChevronRightIcon } from "lucide-react";
import { ICON_SIZE } from "components/common/constants";
import {Tooltip} from "components/tooltip/Tooltip";
import { SHARED_TOOLTIP_ID } from "components/tooltip/AppTooltip.component";



export const TaskDetailsSubnavbar = (props) => {


    const [openEditorState, setOpenEditor] = useState(false);
    const navigate = useNavigate();

    const moveToPreviousBtnRef = React.createRef();
    const moveToNextBtnRef = React.createRef();

    const disableNavigationButtons = () => {
        moveToPreviousBtnRef.current?.classList.add('disabled');
        moveToNextBtnRef.current?.classList.add('disabled');
    }

    const enableNavigationButtons = () => {
        moveToPreviousBtnRef.current?.classList.remove('disabled');
        moveToNextBtnRef.current?.classList.remove('disabled');
    }

    const navigateWithDelay = _.debounce((isForward) => {
        enableNavigationButtons();
        const nextTaskId = props.navigateBetweenTasks(props.params.taskId, isForward);
        navigate(nextTaskId, {replace: true});
    }, 500);

    useEffect(() => {
        enableNavigationButtons();
    }, [props.params.taskId]);


    const openEditor = () => setOpenEditor(true);


    const popUpEditorAvailable = props.taskDetails.externalEditorAvailable && !props.taskDetails.readonly;
    const hasEditorTab = props.taskDetails.externalEditorAvailable;
    const taskWaitingWSUpdate = props.getTasksWaitingWSUpdate && props.getTasksWaitingWSUpdate.includes(props.params.taskId);

    const taskActionButtonsProps = {
        task: props.task,
        taskDetails: props.taskDetails,
        actions: props.activeActions,
        selectedTaskKeys: [props.params.taskId],
        action: props.taskAction,
        translate: props.translate,
        userSettings: props.userSettings,
        openEditorPopup: (popUpEditorAvailable && !hasEditorTab ? openEditor : false),
        backToMyTasks: props.navigateBack,
        isReadOnly: props.editorReadOnly,
        disableAll: props.isTaskDetailsLocked || taskWaitingWSUpdate || props.documentDataLoading || props.workflowDetailsLoading || props.commentsLoading || props.documentPreviewLoading === LOADING_STATUS.LOADING,
        docType: props.type,
        documentVersion: props.taskDetails?.documentVersion,
        isHandled: props.task.isHandled,
        hasDraftComment: props.hasDraftComment,
    };

    //const receivedOn = moment(this.props.task.activatedDate);

    //Removed space and . from translation string too
    const applicationName = props.task.externalApplicationName || props.task.applicationTypeName || '';
    const externalApplicationNameKey = applicationName.replace(/[ .]/g, '');

    return (
        <div className="subnavbar" role={"menubar"}>
            <div className="me-4 cursor-pointer">
                <Button type={ButtonType.GHOST}
                        iconOnly={true}
                        icon={<ArrowLeftIcon size={ICON_SIZE.MEDIUM}/>}
                        onClick={() => {
                            props.navigateBack();
                            navigate(props.navigateBackPath);
                        }}
                        dataCy="taskDetail.subnavbar.backToList"
                        ariaLabel={props.translate("taskDetail.backToList")}
                        tooltip={{id: "subnavbar-back-tooltip", content: () => props.translate("taskDetail.backToList")}}
                />
            </div>

            <div className="subnavbar-document">
                <div className="subnavbar-document-title"
                     data-tip={props.navigation.shortTitle ? "subnavbar-title-tooltip" : undefined}
                     data-for={SHARED_TOOLTIP_ID}
                     data-cy="taskDetail.subnavbar.title">
                    <strong>{props.translate("documentType." + DOCUMENT_TYPE.asString(props.task.documentType))}</strong>
                    {(props.navigation.shortTitle && props.navigation.companyName) ?
                        <span>
                                {' '}- {props.navigation.shortTitle} → {props.navigation.companyName}
                            </span> : null}
                    {props.navigation.shortTitle && (
                        <Tooltip id="subnavbar-title-tooltip" content={() => props.navigation.shortTitle}/>
                    )}
                </div>
                <div className="subnavbar-document-subtitle mt-1" data-cy="taskDetail.subnavbar.subtitle">
                    {props.translate('taskDetail.received')}{' '}
                    {/*{receivedOn.format('DD/MM/YYYY')}*/}
                    {/*{' '}{this.props.translate('taskDetail.at')}{' '}*/}
                    {/*{receivedOn.format('HH:mm')}*/}
                    {applicationName ? <span>
                        {' '}{props.translate('taskDetail.from')}{' '}
                        {props.translationKeyExists(`taskDetail.applicationName.${externalApplicationNameKey}`) ?
                            props.translate(`taskDetail.applicationName.${externalApplicationNameKey}`) : applicationName}
                    </span> : null}
                </div>
            </div>
            <div
                className={`subnavbar-task-action-buttons ms-4 me-2${taskActionButtonsProps.disableAll ? ' disabled' : ''}`}>
                <TaskActionButtons {...taskActionButtonsProps} />
            </div>
            <div className="subnavbar-task-navigation d-flex align-items-center">
                <div>
                        <span data-cy="taskDetail.subnavbar.currentTask">
                            {props.translate('taskDetail.' + props.type + ".type")}
                            <span>
                                {" " + props.navigation.currentTask}
                            </span> / {props.navigation.total}
                        </span>
                </div>
                <div className="d-flex ms-4 me-1 gap-8">
                    <Button
                        type={ButtonType.TRANSPARENT}
                        onClick={() => {
                            disableNavigationButtons();
                            navigateWithDelay(false)
                        }}
                        iconOnly={true}
                        icon={<ChevronLeftIcon size={ICON_SIZE.MEDIUM}/>}
                        disabled={props.navigation.currentTask === 1}
                        ref={moveToPreviousBtnRef}
                        ariaLabel={props.translate("taskDetail.actionBar.moveToPrevious")}
                        dataCy={"taskDetail.actionBar.moveToPrevious"}
                        tooltip={{id: "subnavbar-prev-tooltip", content: () => props.translate("taskDetail.actionBar.moveToPrevious")}}
                    />
                    <Button
                        type={ButtonType.TRANSPARENT}
                        onClick={() => {
                            disableNavigationButtons();
                            navigateWithDelay(true)
                        }}
                        iconOnly={true}
                        icon={<ChevronRightIcon size={ICON_SIZE.MEDIUM}/>}
                        disabled={props.navigation.currentTask === props.navigation.total}
                        ref={moveToNextBtnRef}
                        ariaLabel={props.translate("taskDetail.actionBar.moveToNext")}
                        dataCy={"taskDetail.actionBar.moveToNext"}
                        tooltip={{id: "subnavbar-next-tooltip", content: () => props.translate("taskDetail.actionBar.moveToNext")}}
                    />
                </div>
            </div>
        </div>
    );

}

const withTranslations = translate(TaskDetailsSubnavbar);

const mapStateToProps = (store) => {
    return {
        userSettings: reduxSelectors.getUsersSettings(store),
        documentDataLoading: reduxSelectors.getTaskDocumentDataLoadingStatus(store),
        workflowDetailsLoading: reduxSelectors.getWorkflowDetailsLoadingStatus(store),
        commentsLoading: reduxSelectors.getTaskDraftCommentsLoadingStatus(store),
        documentPreviewLoading: reduxSelectors.getAttachmentsLoadingStatus(store),
        isTaskDetailsLocked: reduxSelectors.getIsTaskDetailsLocked(store),
        hasDraftComment: reduxSelectors.getTaskDraftCommentText(store),
        getTasksWaitingWSUpdate:reduxSelectors.getTasksWaitingWSUpdate(store),
    };
};

const mapDispatchToProps = {};

const withStore = connect(mapStateToProps, mapDispatchToProps)(withTranslations);

export default withStore;